import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { map } from 'rxjs';
import { ChatDialogService } from 'src/app/chat/services/chat-dialog.service';
import { IUser, UserAccountType } from 'src/app/data-types/user-data';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-user-multi-select-area',
    templateUrl: './user-multi-select-area.component.html',
    styleUrls: ['./user-multi-select-area.component.scss'],
})
export class UserMultiSelectAreaComponent implements OnInit {
    @Input() preselectedUserIds: string[] = null;
    @Input() title = 'Members:';
    @Output() usersSelected = new EventEmitter<IUser[]>();
    selectedUsers: IUser[] = [];
    userDialogOpened = false;
    isLoading = false;

    constructor(private chatDialogService: ChatDialogService, private userService: UserService) {}

    ngOnInit(): void {
        if (this.preselectedUserIds?.length > 0) {
            this.isLoading = true;
            this.userService
                .all()
                .pipe(map((res) => res.data))
                .subscribe((users) => {
                    this.selectedUsers = users.filter((u) => this.preselectedUserIds.includes(u.id));
                    this.isLoading = false;
                });
        }
    }

    async selectUserDialog() {
        const selectedUsers: IUser[] = (await this.chatDialogService.openUsersSelectorDlg(
            'many',
            'Apply',
            this.selectedUsers,
            [UserAccountType.Admin],
            false
        )) as IUser[];

        if (!selectedUsers) return;

        this.selectedUsers = selectedUsers;
        this.usersSelected.emit(this.selectedUsers);
    }

    removeUser(userForRemove, $event) {
        this.selectedUsers = this.selectedUsers.filter((m) => m.id !== userForRemove.id);
        this.usersSelected.emit(this.selectedUsers);
        $event.stopPropagation();
    }
}
